import { createFileRoute } from "@tanstack/react-router";

import { OpportunityId } from "@goose/schema/Salesforce";

export const Route = createFileRoute(
  "/_authenticated/admin/opportunity/$opportunityId",
)({
  params: {
    parse: ({ opportunityId }) => {
      return {
        opportunityId: OpportunityId.parse(opportunityId),
      };
    },
  },
});
